<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'

type Props = {
  id?: string
}

defineProps<Props>()

defineEmits(['close'])

let originalOverflow: string

onMounted(() => {
  originalOverflow = document.body.style.overflow
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.body.style.overflow = originalOverflow || ''
})
</script>

<template>
  <div
    :id
    class="bg-modal-wrapper fixed inset-0 z-100 h-screen w-screen overflow-x-hidden overflow-y-scroll"
    @click="$emit('close')"
  >
    <div
      class="absolute top-0 left-1/2 max-h-screen w-full -translate-x-1/2 translate-y-0 transform p-6 lg:top-1/2 lg:w-2/3 lg:-translate-y-1/2 xl:w-1/2"
    >
      <div
        class="bg-silver w-full rounded-md p-5"
        @click.stop
      >
        <slot />
      </div>
    </div>
  </div>
</template>
